import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepCancellationAdditional.sectionTitle',
    defaultMessage: 'Section 3 - Cancellation, additional expenses & travel delay',
  },
  title: {
    id: 'fastCover.stepCancellationAdditional.title',
    defaultMessage: 'Title',
  },
  areYouClaimingForCancellationAmendmentOrDelay: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForCancellationAmendmentOrDelay',
    defaultMessage: 'Are you claiming for a cancellation or amendment to your trip?',
  },
  yes: {
    id: 'fastCover.stepCancellationAdditional.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepCancellationAdditional.no',
    defaultMessage: 'No',
  },
  areYouClaimingForTripCancellationExpenses: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForTripCancellationExpenses',
    defaultMessage: 'Are you claiming for Trip Cancellation Expenses?',
  },
  areYouClaimingForTripDisruptionOrAdditionalExpenses: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForTripDisruptionOrAdditionalExpenses',
    defaultMessage: 'Are you claiming for Trip disruption or Additional Expenses?',
  },
  areYouClaimingForTripResumptionExpenses: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForTripResumptionExpenses',
    defaultMessage: 'Are you claiming for Trip Resumption Expenses?',
  },
  areYouClaimingForAlternativeTransportExpenses: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForAlternativeTransportExpenses',
    defaultMessage: 'Are you claiming for Alternative Transport Expenses?',
  },
  areYouClaimingForATravelDelay: {
    id: 'fastCover.stepCancellationAdditional.areYouClaimingForATravelDelay',
    defaultMessage: 'Are you claiming for a Travel Delay?',
  },
  dateCancellationOrAmendmentMade: {
    id: 'fastCover.stepCancellationAdditional.dateCancellationOrAmendmentMade',
    defaultMessage: 'Date cancellation or amendment made',
  },
  reasonForCancellationOrAmendment: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment',
    defaultMessage: 'Reason for cancellation/amendment',
  },
  medical: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment.medical',
    defaultMessage: 'Medical reasons (illness or injury) - Please also complete Section 13 Medical Certificate and Section 12 Medical authority',
  },
  travel: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment.travel',
    defaultMessage: 'Travel provider (Airline, hotel, cruise liner, tour company etc)',
  },
  weather: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment.weather',
    defaultMessage: 'Weather event',
  },
  redundancy: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment.redundancy',
    defaultMessage: 'Redundancy',
  },
  other: {
    id: 'fastCover.stepCancellationAdditional.reasonForCancellationOrAmendment.other',
    defaultMessage: 'Other (please describe)',
  },
  cancellationExpenses: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses',
    defaultMessage: 'Cancellation Expenses',
  },
  addCancellationExpense: {
    id: 'fastCover.stepCancellationAdditional.addCancellationExpense',
    defaultMessage: 'Add cancellation expense',
  },
  cancellationExpenseTitle: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenseTitle',
    defaultMessage: 'Cancellation Expense {index}',
  },
  cancellationExpensesDateCancelled: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.dateCancelled',
    defaultMessage: 'Date Cancelled',
  },
  cancellationExpensesCancelledBookingDescription: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.cancelledBookingDescription',
    defaultMessage: 'Cancelled Booking Description',
  },
  cancellationExpensesSupplier: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.supplier',
    defaultMessage: 'Travel Provider',
  },
  cancellationExpensesPrePaidAmount: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.cancellationExpensesPrePaidAmount',
    defaultMessage: 'Pre-Paid Amount',
  },
  cancellationExpensesRefundCompensationReceived: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.refundCompensationReceived',
    defaultMessage: 'Refund/Compensation Received',
  },
  cancellationExpensesCurrency: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.cancellationExpensesCurrency',
    defaultMessage: 'Currency',
  },
  textBoxEg: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenses.textBoxEg',
    defaultMessage: 'e.g: {value}',
  },
  additionalExpenses: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses',
    defaultMessage: 'Additional Expenses',
  },
  additionalExpenseTitle: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenseTitle',
    defaultMessage: 'Additional Expense {index}',
  },
  addAdditionalExpense: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.addAdditionalExpense',
    defaultMessage: 'Add Additional expenses',
  },
  additionalExpensesDateOfExpense: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  additionalExpensesDescription: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.description',
    defaultMessage: 'Description',
  },
  additionalExpensesSupplier: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.supplier',
    defaultMessage: 'Travel Provider',
  },
  additionalExpensesAmountPaid: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.amountPaid',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },
  additionalExpensesCurrency: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenses.additionalExpensesCurrency',
    defaultMessage: 'Currency',
  },
  delayedTravelTitle: {
    id: 'fastCover.stepCancellationAdditional.delayedTravelTitle',
    defaultMessage: 'Delayed Travel',
  },
  whatWasTheReasonForYourDelay: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.whatWasTheReasonForYourDelay',
    defaultMessage: 'What was the reason for your delay?',
  },
  dateYouWereDueToDepart: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },
  timeYouWereDueToDepart: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },
  dateYouActuallyDeparted: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },
  timeYouActuallyDeparted: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },
  didYouReceiveAnyCompensationFromYourTravelProvider: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.didYouReceiveAnyCompensationFromYourTravelProvider',
    defaultMessage: 'Did you receive any compensation from your Travel Provider?',
  },
  didYouReceiveAnyCompensationFromYourTravelProviderTextNote: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.didYouReceiveAnyCompensationFromYourTravelProviderTextNote',
    defaultMessage: 'Airline, hotel, cruise liner, tour company etc.',
  },
  delayedTravelExpenses: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses',
    defaultMessage: 'Delayed Travel Expenses',
  },
  addDelayExpense: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.addDelayExpense',
    defaultMessage: 'Add Delay Expense',
  },
  delayedTravelExpenseTitle: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.delayedTravelExpenseTitle',
    defaultMessage: 'Delay Expense {index}',
  },
  delayedTravelExpenseDate: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.date',
    defaultMessage: 'Date of Expense',
  },
  delayedTravelExpenseDescription: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.description',
    defaultMessage: 'Description',
  },
  delayedTravelExpenseAmount: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.amount',
    defaultMessage: 'Amount',
  },
  delayedTravelExpenseCurrency: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.currency',
    defaultMessage: 'Currency',
  },
  delayedTravelExpenseAmountRefunded: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.amountRefunded',
    defaultMessage: 'Amount refunded from originally planned expense',
  },
  delayedTravelExpenseAmountClaimed: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  addDelayedTravelExpense: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.addDelayedTravelExpense',
    defaultMessage: 'Add Delayed travel expense',
  },
  ifNoAmountRefundedThenEnterZero: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.delayedTravelExpenses.ifNoAmountRefundedThenEnterZero',
    defaultMessage: '(If no amount refunded then enter zero)',
  },
  cancellationExpenseRequired: {
    id: 'fastCover.stepCancellationAdditional.cancellationExpenseRequired',
    defaultMessage: 'Cancellation Expense table fields are required fields.',
  },
  additionalExpenseRequired: {
    id: 'fastCover.stepCancellationAdditional.additionalExpenseRequired',
    defaultMessage: 'Additional Expense table fields are required fields.',
  },
  delayedTravelExpensesRequired: {
    id: 'fastCover.stepCancellationAdditional.delayedTravelExpensesRequired',
    defaultMessage: 'Delayed Travel Expenses table fields are required fields.',
  },
  dateRefundWasReceived: {
    id: 'fastCover.stepCancellationAdditional.dateRefundWasReceived',
    defaultMessage: 'Date Refund was Received',
  },
  amountOfCompensation: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepCancellationAdditional.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepCancellationAdditional.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepCancellationAdditional.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepCancellationAdditional.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  isRequired: {
    id: 'fastCover.stepCancellationAdditional.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  areThereAnyAdditionalExpensesToBeClaimed: {
    id: 'fastCover.stepCancellationAdditional.areThereAnyAdditionalExpensesToBeClaimed',
    defaultMessage: 'Are there any additional expenses to be claimed?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/messages.js